<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card mt-1">
                <div class="card-body p-4">
                    <div class="d-flex mb-4 mt-1 justify-content-between">
                        <view-pr-details [purchaseRequest]="purchaseRequest" [prInitiatorForm]="purchaseRequestForm"></view-pr-details>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="modal-footer">
        <a class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</a>
    </div> -->
</section>